import { cr, interact } from "fire-wind-water";
import { Elem } from "./elem";
import { yearPicker } from "./virtual/year";
import { relustList } from "./core/list";
import { initTrTd } from "./virtual/trthtd";
import { classNames } from "./core/setting";

class Year extends Elem {
  list: any;
  constructor(o) {
    super(o);
    this.resetModel = ["year"];
  }

  setList(o?) {
    const d = cr.extend({}, this.value);
    if (o) {
      d.year = o;
    }
    this.list = relustList("year", d, this.model);
  }

  setModel(o) {
    const date = cr.isDate(o) ? o : new Date();
    this.setValue(date);
    this.resetRender();
  }

  resetRender(d?) {
    if (interact.isMobile === 1) {
      this.resetWapRender(d);
    } else {
      this.setList();
      this.setVirtual();
      this.render();
    }
  }

  setVirtual() {
    const trs = initTrTd("year", this.list, 3, (o) => {
      this.selectItem(o);
    });
    this.virtual = yearPicker(this, trs);
  }

  selectItem(o) {
    this.value.year = o.year;
    this.model = this.toDate();
    cr.each(this.items, (d) => {
      d.className =
        d.year === this.value.year ? classNames.active : classNames.default;
    });
    if (o === this.list[0]) {
      this.selectFirst();
    } else if (o === this.list[this.list.length - 1]) {
      this.selectLast();
    }
    this.change({ model: this.model, value: this.value });
  }

  selectFirst(ev?) {
    if (ev) {
      ev.stopPropagation();
    }
    const value = this.list[0].year;
    this.setList(value);
    this.setVirtual();
    this.render();
  }

  selectLast(ev?) {
    if (ev) {
      ev.stopPropagation();
    }
    const value = this.list[this.list.length - 1].year;
    this.setList(value);
    this.setVirtual();
    this.render();
  }

  changeModel() {
    this.touchs.changeModel(this.value);
    this.model = this.toDate();
    this.change({ model: this.model, value: this.value });
    this.destroy();
  }
}

export { Year };
